export const Share = () => {
  const share = document.querySelector(".js-share");
  const shareBtn = document.querySelector(".js-share__btn");
  const shareList = document.querySelector(".js-share__list");

  shareBtn?.addEventListener("click", () => {
    share.classList.toggle("is-show");
    shareList.classList.toggle("is-show");
    shareBtn.classList.toggle("is-show");
  });
};
